/**
 * Config các danh mục cần validate mã con bắt đầu bằng mã cha khi cất
 * NXCHIEN 29.06.2022
 */
export default {
  di_account: {
    isCheckValidateChildCode: true, // có check mã con bắt đầu bằng mã cha
    mesGroup: 'số tài khoản tổng hợp và nhóm tài khoản',
    mesParent: 'số tài khoản tổng hợp',
    mesChild: 'Số tài khoản',
  },
  di_budget_source: {
    isCheckValidateChildCode: true, // có check mã con bắt đầu bằng mã cha
    isCheckChildCodeSameLevel: true, // có check không được thêm mã bắt đầu bằng mã con cùng cấp
    parentKey: 'parent_code',
    mesParent: 'Nguồn kinh phí',
    mesChild: 'nguồn kinh phí',
  },
  di_task: {
    isCheckValidateChildCode: true, // có check mã con bắt đầu bằng mã cha
    isCheckChildCodeSameLevel: true, // có check không được thêm mã bắt đầu bằng mã con cùng cấp
    parentKey: 'parent_code',
    mesParent: 'Nhiệm vụ',
    mesChild: 'nhiệm vụ',
  },
};
